var _rect, _line, _circle, _circle2, _circle3, _text, _text2, _text3, _text4, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "timelineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#E5DECF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#5F7A61",
      stopOpacity: 0.3
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 100,
    fill: "url(#timelineGradient)",
    rx: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 50,
    x2: 380,
    y2: 50,
    stroke: "#E5DECF",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 8,
    fill: "#5F7A61"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 8,
    fill: "#E5DECF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 50,
    r: 8,
    fill: "#5F7A61"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 30,
    fill: "#1C1917",
    fontSize: 12,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "1975")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 30,
    fill: "#1C1917",
    fontSize: 12,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "Growth")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 30,
    fill: "#1C1917",
    fontSize: 12,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "Today")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 75,
    fill: "#44403C",
    fontSize: 10,
    textAnchor: "middle"
  }, "Founded")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 75,
    fill: "#44403C",
    fontSize: 10,
    textAnchor: "middle"
  }, "Pastors")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 75,
    fill: "#44403C",
    fontSize: 10,
    textAnchor: "middle"
  }, "Continuing")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/timeline-icon.325dc277ba9528461b002ae196110398.svg";
export { ForwardRef as ReactComponent };